import { render, staticRenderFns } from "./NwFormConscious.vue?vue&type=template&id=b70610e4&scoped=true&"
import script from "./NwFormConscious.vue?vue&type=script&lang=js&"
export * from "./NwFormConscious.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70610e4",
  null
  
)

export default component.exports